import { render, staticRenderFns } from "./ListQuotationComplaints.vue?vue&type=template&id=0d329cae&scoped=true&"
import script from "./ListQuotationComplaints.vue?vue&type=script&lang=ts&"
export * from "./ListQuotationComplaints.vue?vue&type=script&lang=ts&"
import style0 from "./ListQuotationComplaints.vue?vue&type=style&index=0&id=0d329cae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d329cae",
  null
  
)

export default component.exports